import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import TaxPage from "../screens/Tax/TaxPage";
import TaxDetails from "../screens/Tax/TaxDetails";
import K1TotalSummary from "../screens/Tax/K1TotalSummay";

const Stack = createStackNavigator();

const TaxStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="Taxes" component={TaxPage} />
      <Stack.Screen name="TaxDetails" component={TaxDetails} />
      <Stack.Screen name="K1TotalSummary" component={K1TotalSummary} />
    </Stack.Navigator>
  );
};

export default TaxStackNavigator;
